// One day, picked on the same calendar popover a period uses (finance-real, the user 2026-10-23: "same entities should
// use same components"): DateRangePicker in single mode, its field reading the day as every finance date reads ("8 Sep
// 2026"). The day a job or a quote starts, a payment arrived and a team invoice was paid out. Days are ISO strings, ""
// for none.
import { DateRangePicker } from "./DateRangePicker";

interface Props {
  value: string;
  onChange: (iso: string) => void;
  /** Names the field. */
  ariaLabel: string;
  placeholder?: string;
  disabled?: boolean;
  /** The last day it offers, ISO: a day paid is never after today. */
  max?: string;
  /** Marks the field aria-required. */
  required?: boolean;
}

export function DayField({ value, onChange, ariaLabel, placeholder = "Pick the day", disabled = false, max, required = false }: Props) {
  return (
    <DateRangePicker
      single
      ariaLabel={ariaLabel}
      placeholder={placeholder}
      disabled={disabled}
      max={max}
      required={required}
      value={{ from: value, to: "" }}
      onChange={(range) => onChange(range.from)}
    />
  );
}
